import * as React from "react";
const SvgVerticalLine = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 2, height: 24, viewBox: "0 0 2 24", fill: "none", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M1 0V24", stroke: "#E9EAF4" }));
export default SvgVerticalLine;
